/**
 * @fileoverview The line under a plant's name on its card and its list row:
 * whatever the view adds ("Sown 12 May", the sort's date), and nothing else.
 *
 * It used to name the type ("Romaine Lettuce" under "Devil's Ear"). The one
 * naming rule (2026-10-14, services/grow/plantNaming) says a plant's name
 * whole ("Devil's Ear Lettuce", "Butterhead Lettuce") and keeps the kind in
 * the About sheet, so the line is the view's extra alone.
 *
 * Where: the plant card (PlantCard) and the list row (PlantRow).
 * API: none.
 * Settings: none.
 *
 * @module plantSubtitle
 */

import { Plant } from '@/shared/types/plant';

/**
 * The view's extra, or null when there is nothing to say.
 *
 * @param plant - The plant shown (its name is the title; nothing of it goes here).
 * @param extra - What the view adds, if anything.
 * @returns The line, or null when there is nothing to say.
 */
export function plantSubtitle(plant: Plant, extra?: string | null): string | null {
  void plant;
  return extra?.trim() || null;
}
